import { render } from "./TheHeader.vue?vue&type=template&id=6010e40c&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=6010e40c&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6010e40c"]])

export default __exports__